<template>
  <div class="nav-content">
    <div style="margin-top: 40px">
      <Breadcrumb separator=">">
        <BreadcrumbItem @click.native="back()" class="content-item">首页</BreadcrumbItem>
        <BreadcrumbItem @click.native="go()" class="content-item">{{
          this.title
        }}</BreadcrumbItem>
        <BreadcrumbItem v-if="state" class="content-item">{{
          this.name
        }}</BreadcrumbItem>
        <BreadcrumbItem class="content-item">详情</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div>
      <div class="content-left">
        <div
          style="margin-top: 17px;height: 62px;border-bottom: 1px solid #EAEAEA;width: 100%;">
          <ul>
            <li>来源: 北京久其软件</li>
            <li>分类: 工作</li>
            <li>类型: 原创</li>
            <li>发布日期: 2022-6-20</li>
          </ul>
        </div>
        <div
          style="font-size: 36px;font-weight: 600;line-height: 50px;color: #424242;text-align: left;margin-top: 20px;margin-left: 20px;">
          {{ this.total }}
        </div>
        <div v-html="txt" class="iten" style="min-height: 487px"></div>
        <div class="itn">
          <div style="margin-top: 40px;text-align: left;color: #0f0f0f;font-family: PingFangSC-Medium;font-weight: 500;font-size: 18px;">相关附件:</div>
          <div style="overflow: hidden; margin-bottom: 15px" v-for="(item, index) in list" :key="index">
            <div style="float: left; line-height: 32px">{{ item.name }}</div>
            <div class="icons" @click="dow(item)">下载</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-right">
      <div class="content-right1">本项目相关信息</div>
      <div class="content-right2">
        <div v-on:click="setActive('a')" :class="rightActive == 'a'? 'right-active1' : 'right-gonggao'">本项目相关公告</div>
        <div v-on:click="setActive('b')" :class="rightActive == 'b'? 'right-active1' : 'right-jindu'">本项目采购进度</div>
      </div>
      <div v-show="rightActive == 'a'" class="xggg-items">
          <div @click="toURL('采购公告')" style="cursor: pointer;" class="xggg-item xggg-item-active">采购公告</div>
          <div @click="toURL('结果公示')" style="cursor: pointer;" class="xggg-item">结果公示</div>
          <div @click="toURL('验收公告')" style="cursor: pointer;" class="xggg-item">验收公告</div>
      </div>
      <div v-show="rightActive == 'b'" class="cgjd-items">
        <Timeline>
            <TimelineItem style="height:100px" color="green">
                <template #dot>
                    <div class="timedot"></div>
                </template>
                <p style="margin-top: 40px;" class="content">采购计划采购进度</p>
            </TimelineItem>
            
            <TimelineItem v-for="(item, index) in jinduList" :key="index">
                <p class="time">{{item.title}}</p>
            </TimelineItem>
        </Timeline>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail",
  components: {},
  data() {
    return {
      txt: "",
      list: [],
      title: "",
      name: "",
      total: "",
      state: true,
      rightActive:"a",
      jinduList:[
        {title:"申请人提交设备采购论证申请"},
        {title:"需求部门领导已审核"},
        {title:"学校设备科初审"},
        {title:"校级组织设备采购论证并出具论证意见"},
        {title:"需求部门修改论证报告并上报修改说明"},
        {title:"设备采购论证通过"},
        {title:"采购科接收采购材料"},
        {title:"采购材料转交采购管理科"},
        {title:"采购科完成审查，编制采购计划"},
        {title:"采购管理科完成采购文件编制"},
        {title:"需求部门完成采购文件审查"},
        {title:"采购公告公示"},
        {title:"采购科开标评审"},
        {title:"成交结果公示"},
        {title:"采购合同起草"},
        {title:"使用单位审阅合同"},
        {title:"采购部门审阅合同"},
        {title:"法律部门审阅合同"},
        {title:"需求部门对设备进行初验"},
        {title:"国资处组织对设备进行终验"},
        {title:"支付合同款"},
        {title:"采购完成"}
      ]
    };
  },
  watch: {
    //监听当前路由并更新对应数据
    $route: {
      handler: function (to, from) {
        let qwe = this.$route.query;
        this.title = qwe.title;
        if (qwe.name) {
          this.state = true;
          this.name = qwe.name;
        } else {
          this.state = false;
        }
        this.total = qwe.total;
        this.getDetail();
      },
      deep: true
    }
  },
  //保证刷新的时候（此时路由没有变化）可以实现一边基本操作
  mounted() {
    let qwe = this.$route.query;
    this.title = qwe.title;
    if (qwe.name) {
      this.state = true;
      this.name = qwe.name;
    } else {
      this.state = false;
    }
    this.total = qwe.total;
    this.getDetail();
  },
  methods: {
    toURL(title){
      if(title == "采购公告"){
        this.$router.push({
          path: "/home/infoDetail",
          query: {
            guid: '0192D757421A0D00A05DA6C9BDAF8F51',
            title: '信息公开',
            name: '采购意向公告',
            total: '@红外热像仪、光合仪人工光源、土壤多参数监测系统采购进口设备材料公示'
          }
        });
      }else if(title == '结果公示'){
        this.$router.push({
          path: "/home/infoDetail",
          query: {
            guid: '0192E16C396F0D00F10FC2F75EFBB830',
            title: '信息公开',
            name: '结果公告',
            total: '@红外热像仪、光合仪人工光源、土壤多参数监测系统采购进口设备采购成交结果公告'
          }
        })
      } else if(title == '验收公告'){
        this.$router.push({
          path: "/home/infoDetail",
          query: {
            guid: '0192E16A09AB0D00FB4B382857C854AE',
            title: '信息公开',
            name: '验收公告',
            total: '@红外热像仪、光合仪人工光源、土壤多参数监测系统采购进口设备验收公告'
          }
        });
      }
    },
    setActive(data){
      this.rightActive = data
    },
    //获得后台富文本编辑内容
    getDetail() {
      // let pram = localStorage.getItem("guid");
      let pram = this.$route.query.guid;
      GMS.$http
        .get(`/portal/cms/content/?guid=` + pram)
        .then(res => {
          if (res.status == 200) {
            this.txt = res.data.datas.data.text; //正文
            this.list = res.data.datas.attachements; //附件
          }
        })
        .catch(error => {
          this.$Message.error("获取数据异常");
        });
    },
    //下载附件
    dow({ guid, name = "download" }) {
      GMS.$http
        .get("/portal/cms/file?guid=" + guid, {
          responseType: "blob"
        })
        .then(res => {
          let blob = new Blob([res.data], {
            type: "multipart/form-data;charset=utf-8"
          });
          //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let iconv = require("iconv-lite");
          iconv.skipDecodeWarning = true; //忽略警告
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = name; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
        });
    },
    back() {
      if (this.$route.path.startsWith("/home")) {
        // 当前路由是以 /home 开头的
        this.$router.push("/home");
      } else if (this.$route.path.startsWith("/Portal")) {
        // 当前路由是以 /Portal 开头的
        this.$router.push("/Portal");
      }
    },
    go() {
      let list1 = JSON.parse(sessionStorage.getItem("navList"));
      let res = list1.find(item => item.title === this.title);
      if (this.$route.path.startsWith("/home")) {
        // 当前路由是以 /home 开头的
        if (res.childList.length === 0) {
          this.$router.push({
            path: "/home/solution",
            query: {
              id: res.id
            }
          });
        } else {
          this.$router.push({
            path: "/home/solution",
            query: {
              id: res.id,
              tagnum: res.childList[0].ordina
            }
          });
        }
      } else if (this.$route.path.startsWith("/Portal")) {
        // 当前路由是以 /Portal 开头的
        if (res.childList.length === 0) {
          this.$router.push({
            path: "/Portal/solution",
            query: {
              id: res.id
            }
          });
        } else {
          this.$router.push({
            path: "/Portal/solution",
            query: {
              id: res.id,
              tagnum: res.childList[0].ordina
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.demo-breadcrumb-separator {
  padding-left: 16px;
  line-height: 42px;
  color: #7f7f7f;
  font-size: 18px;
  font-weight: 400;
}

.iten {
  margin-top: 40px;
  text-align: left;
}

.itn {
  margin-top: 63px;
  margin-bottom: 24px;
}

.icons {
  float: right;
  width: 64px;
  height: 32px;
  text-align: center;
  cursor: pointer;
  background-color: #006ac0;
  border-radius: 4px;
  line-height: 32px;
  color: #ffffff;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
}

.content-item {
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  color: #424242;
  line-height: 42px;
  font-family: PingFangSC-S0pxibold;
}

.content-left ul li {
  float: left;
  list-style: none;
  color: #424242;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 15px;
  line-height: 62px;
  margin-right: 32px;
}

.nav-content {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 1500px) {
  .nav-content {
    width: 1200px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1800px) {
  .nav-content {
    width: 1400px;
  }
}

@media screen and (min-width: 1800px) {
  .nav-content {
    width: 1600px;
  }
}

.content-left {
  width: calc(100% - 416px);
  float: left;
  border: 1px solid #EAEAEA;
  margin-right: 24px;
}
.content-right{
  float: left;
  width: 392px;
}
.content-right1{
  width: 392px;
  height: 70px;
  background-size: 100% 100%;
  background-image: url('../../../static/ligong/xgxxbg.webp');
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  text-indent: 20px;
  line-height: 70px;
  margin-bottom: 18px;
}
.content-right2{
  height: 44px;
  background: #F3F3F3;
  border-radius: 4px;
  margin-bottom: 20px;
}
.right-gonggao{
  width: 50%;
  height: 40px;
  float: left;
  cursor: pointer;
  color: #7F7F7F;
  line-height: 44px;
  text-align: center;
}
.right-jindu{
  width: 50%;
  height: 40px;
  float: left;
  cursor: pointer;
  color: #7F7F7F;
  line-height: 44px;
  text-align: center;
}
.right-active1{
  width: 50%;
  background: #FFFFFF;
  border-radius: 4px;
  color: #424242;
  float: left;
  height: 40px;
  margin-top: 2px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.xggg-items{
  width: 100%;
  
}
.xggg-item{
    width: 100%;
    height: 50px;
    border: 1px solid #F3F3F3;
    font-size: 16px;
    color: #424242;
    line-height: 50px;
    text-indent: 24px;
}
.xggg-item-active{
  color: #015293;
}
.cgjd-items{
  width: 100%;
  min-height: 400px;
}
.timedot{
  width: 28px;
  height: 28px;
  background-image: url('../../../static/ligong/liucheng.webp');
  background-size: 100% 100%;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/inside/informationDetail.vue